import { TwSolicitudJerarquiaExViewModel } from '../datosbasicos/datosbasicosEx.types';

export class SolicitudAnulacionExViewModel {
    public Id: number;
    public IdEstadoSolicitudEx = 0;
    public IdEstadoSolicitudExDescripcion: string;
    public IdEstadoCertificadoFitoEx: number;
    public IdEstadoCertificadoFitoExDescripcion: string;
    public IdTipoSolicitudEx: number;
    public IdTipoSolicitudExDescripcion: string;
    public IdResultadoEnvioMuestrasLaboratorioEx: number | null;
    public DescripcionIdResultadoEnvioMuestrasLaboratorioEx: string;
    public CodigoTipoSolicitud: string;
    public CodigoSolicitud: string;
    public NumeroCertificado: string;
    public EsPrevia: boolean;
    public EsEphyto: boolean;
    public IdSubTipoSolicitudEx: number | null;
    public IdSubTipoSolicitudExDescripcion: string;
    public TAnulacionEx: TAnulacionSolicitudExViewModel;
    public TwSolicitudJerarquiaEx: TwSolicitudJerarquiaExViewModel;
}

export class TAnulacionSolicitudExViewModel {
    public Id: number;
    public IdSolicitudEx: number;
    public IdUsuario: number;
    public NombreUsuario = '';
    public Observaciones = '';
    public Fecha: Date;
}
